import { v4 as uuidv4 } from 'uuid';
import Img1 from '../../assets/img/project/Group17.png';
import Img2 from '../../assets/img/project/Group18.png';
import Img3 from '../../assets/img/project/Group19.png';
import Img4 from '../../assets/img/project/Group20.png';
import Img5 from '../../assets/img/project/Group21.png';
import Img6 from '../../assets/img/project/Group22.png';
import Img7 from '../../assets/img/project/Group23.png';
import Img8 from '../../assets/img/project/Group24.png';
import Img9 from '../../assets/img/project/Group25.png';
import Img10 from '../../assets/img/project/Group26.png';

const portfolioOneData = [{
        id: uuidv4(),
        image: Img1,
        category: 'Industrial: Casting',
        heading: 'Anugraha',
        desc: 'Sri Lakshmi Enterprise is an exceptional company that I had the pleasure of working with recently. Their expertise in casting mold, sand molding, fabrication, industrial shed construction, and sand mixture services is truly impressive. They have a skilled team of professionals who are dedicated to delivering high-quality products on time and within budget.',
        btnText: 'Case Details',
    },

    {
        id: uuidv4(),
        image: Img2,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'LAMINA Foundry Limited',
        desc: 'Sri Lakshmi Enterprise in Coimbatore is an exceptional company that offers top-quality casting mold, sand molding, fabrication, industrial shed construction, and sand mixture services. Their attention to detail, commitment to customer satisfaction, and skilled team of professionals make them the ideal choice for any project.',
        btnText: 'Case Details',
    },

    {
        id: uuidv4(),
        image: Img3,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'Sharp Tools Manufacturer',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliqui',
        btnText: 'Case Details',
    },

    {
        id: uuidv4(),
        image: Img4,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'Sri Deivam Foundry',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliqui',
        btnText: 'Case Details',
    },
    {
        id: uuidv4(),
        image: Img5,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'SSA Casting',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliqui',
        btnText: 'Case Details',
    },
    {
        id: uuidv4(),
        image: Img6,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'AMEX IRONS',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliqui',
        btnText: 'Case Details',
    },
    {
        id: uuidv4(),
        image: Img7,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'tCF - Technocast Foundry',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliqui',
        btnText: 'Case Details',
    },
    {
        id: uuidv4(),
        image: Img8,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'murugappa',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliqui',
        btnText: 'Case Details',
    },
    {
        id: uuidv4(),
        image: Img9,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'Shanthi Gears',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliqui',
        btnText: 'Case Details',
    },
    {
        id: uuidv4(),
        image: Img10,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'Karthikeya',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliqui',
        btnText: 'Case Details',
    }
];

export default portfolioOneData;